import { createSlice } from "@reduxjs/toolkit";
import { globalActions } from "../actions";

const initialState = {
	items: { dict: {}, list: [] },
	requireRefresh: false,
	pagination: { totalPages: 1, totalRecords: 0, pageNumber: 1, pageSize: 0 },
};

const serviceRequestSlice = createSlice({
	name: "serviceRequest",
	initialState,
	reducers: {
		setServiceRequest: (state, action) => {
			const pagination =
				action.payload?.pagination || initialState.pagination;
			const itemsAsList = action.payload?.data || [];
			state.items.list = itemsAsList;
			for (let i = 0; i < itemsAsList.length; i++) {
				const item = { ...itemsAsList[i], listPosition: i };
				state.items.dict[item.id] = item;
			}
			state.pagination = {
				totalPages: pagination.total_pages,
				totalRecords: pagination.total_records,
				pageNumber: pagination.page_number,
				pageSize: pagination.page_size,
			};
		},
		updateServiceRequest: (state, action) => {
			const payload = action.payload;
			if (payload instanceof Array) {
				const items = payload;
				items.forEach((item) => {
					if (item.id in state.items.dict) {
						const itemListPosition =
							state.items.dict[item.id].listPosition;
						state.items.list[itemListPosition] = item;
						state.items.dict[item.id] = {
							...item,
							listPosition: itemListPosition,
						};
					}
				});
			} else {
				const item = payload;
				if (item.id in state.items.dict) {
					const itemListPosition = state.items.dict[item.id].listPosition;
					state.items.list[itemListPosition] = item;
					state.items.dict[item.id] = {
						...item,
						listPosition: itemListPosition,
					};
				}
			}
		},
		resetServiceRequest: (state) => initialState,
	},
	extraReducers: (builder) => {
		builder.addCase(globalActions.logout, () => initialState);
	},
});

const getServiceRequestItemsAsDict = (state) => state.serviceRequest.items.dict;

const getServiceRequestItemsAsList = (state) => state.serviceRequest.items.list;

const getServiceRequestRequireRefresh = (state) => state.serviceRequest.requireRefresh;

const getServiceRequestPagination = (state) => state.serviceRequest.pagination;

export {
	getServiceRequestItemsAsDict,
	getServiceRequestItemsAsList,
	getServiceRequestRequireRefresh,
	getServiceRequestPagination,
};

export default serviceRequestSlice;
